<template
  ><article
    class="device-card"
    :data-sorting="$store.state.configinfo.objectMoveState ? 'true' : null"
    :class="[
      'device-card--' + cardStatus.state,
      { selected: viewType === 'configDevice' && oneDevice.followState === 1, 'has-action': viewType === 'configDevice' || (!viewType && deviceViewType === '开关样式') }
    ]"
    tabindex="0"
    role="button"
    :aria-pressed="viewType === 'configDevice' ? oneDevice.followState === 1 : undefined"
    :aria-label="oneDevice.remark"
    @keydown.enter.prevent="deviceBtnClickHandle"
    @click="deviceBtnClickHandle"
    @contextmenu.prevent="deviceRightClickBtnHandle"
  >
    <div class="device-card-top">
      <span class="device-icon-surface"><img :src="oneDevice.iconUrl" alt=""/></span>
      <div v-if="!viewType" class="device-status-copy">
        <div class="device-card-status" :title="cardStatus.primary">{{ cardStatus.primary }}</div>
        <div class="device-card-detail" :title="cardStatus.secondary">
          {{ cardStatus.secondary }}
        </div>
      </div>
      <span v-else-if="viewType === 'configDevice' && oneDevice.followState === 1" class="selection-badge">{{
        oneDevice.followOrder
      }}</span>
    </div>
    <ellipsis-tooltip class="device-card-name" :text="oneDevice.remark" />
    <div class="device-card-bottom">
      <ellipsis-tooltip class="device-card-region" :text="oneDevice.regionName" /><span
        v-if="!viewType && deviceViewType === '开关样式'"
        class="quick-switch"
        :class="{ on: cardStatus.state === 'active' }"
        ><i
      /></span>
      <span v-if="viewType === 'configDevice'" class="card-selection device-selection" :class="{ checked: oneDevice.followState === 1 }" aria-hidden="true"></span>
    </div></article
></template>
<script>
import { deviceControlEntry } from '@/common/device-control-entry.js'
import EllipsisTooltip from 'components/common/ellipsis-tooltip/ellipsis-tooltip'
import { judgeActivePage, publicFadeInOut, jieMianStateJudge } from 'common/tool'
import { controlBtnRequestHandle } from 'components/content/control-toast/control-toast-classify/device-public-js'
import {
  getDeviceCardStatus,
  deviceTypeJudge,
  deviceTypeJudge1,
  deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
export default {
  components: { EllipsisTooltip },
  data() {
    return {
      userControlData: {
        ////部分没有二级页面的数据需要
        openState: this.oneDevice.openState, ///1开 或0关
        openStateValue: this.oneDevice.openStateValue, //无用
        openStateValue1: this.oneDevice.openStateValue1, ///无用
        openStateValue2: this.oneDevice.openStateValue2 ///无用
      }
    }
  },
  props: {
    disabled: { type: Boolean, default: false },
    oneDevice: Object,
    viewType: {
      type: String,
      default: ''
    }
  },
  methods: {
    deviceBtnClickHandle() {
      if (this.disabled) return
      //设备点击时弹出控制窗
      ///判断当前设备类型  是否和后面的'01' , '021' , '05'相同，相同返回true
      // viewType === ''这个参数用来判断设备显示的类型，  空的时候，代表是正常的控制页面类型-
      if (!jieMianStateJudge()) return ///界面管理状态判断

      if (this.viewType === '') {
        if (
          deviceControlEntry(this.oneDevice.productCode) === 'switch' //代号 20231207-1
        ) {
          deviceStateFlip(this.userControlData) ///对设备的状态0和1进行翻转
          controlBtnRequestHandle(this.userControlData, this.oneDevice) ///控制请求服务端的公共方法
          return
        } else {
          this.$showControlToast('device', this.oneDevice)
          this.$store.dispatch('asyUpdataobjData', this.oneDevice) ///异步提交二级页面展示的数据，用于二级页面的实时状态更新 20200405添加
        }
      } else if (this.viewType === 'configDevice') {
        ////当前处于勾选常用设备的页面
        if (this.oneDevice.followState === 1) {
          ///取消收藏
          this.$emit('followOrderCompuder', this.oneDevice.followOrder)
          this.oneDevice.followState = 0
          this.oneDevice.followOrder = 0
        } else {
          ///添加收藏
          this.$emit('followOrderCompuInc', this.oneDevice)

          this.oneDevice.followState = 1
        }
      }
    },
    deviceRightClickBtnHandle() {
      // 主账号判断  0主账号
      console.log('当前是子账号不支持')
      console.log('设备对象右击了')
      if (!jieMianStateJudge()) return ///界面管理状态判断
      if (sessionStorage.getItem('userType') != '0') return

      this.$showTipsToast(11, this.oneDevice)
    }
  },
  watch: {
    oneDevice: {
      handler(newValue, oldValue) {
        console.log('单个数据发生了改变')

        this.useroneDevice = newValue
        // 这里与PC的处理逻辑不同,这里是用户点下之后就翻转更新显示状态,然后再根据实际返回结果,恢复原来状态,或保持成功状态
        //解决 控制页面接收到socket数据之后  显示发生变化  实际在点击控制时 状态翻转出现的BUG
        this.userControlData.openState = newValue.openState
        this.userControlData.openStateValue = newValue.openStateValue
        this.userControlData.openStateValue1 = newValue.openStateValue1
        this.userControlData.openStateValue2 = newValue.openStateValue2

        if (this.$store.state.publicinfo.objData.deviceId) {
          if (this.$store.state.publicinfo.objData.deviceId === newValue.deviceId) {
            console.log('有一个二级页面需要更新')
            console.log(newValue)
            ////发送一个事件句柄消息到 二级控制页面用于状态实时同步更新 （不能用VUEx暂时搞不不明白）
            window.dispatchEvent(
              new CustomEvent('control2PageUpdata', {
                detail: {
                  data: newValue
                }
              })
            )
            // this.bus.$emit('control2PageUpdata', newValue)
            // this.$store.dispatch('asyUpdataobjData', this.oneDevice) ///异步提交二级页
          }
        } else {
          console.log('单个数据发生了改变,当前二级控制页面未打开不需要更新')
        }
      },
      deep: true //深度监听,监听数组的第二层数据变化
    }
  },
  computed: {
    cardStatus() {
      return getDeviceCardStatus(this.oneDevice, this.oneDevice)
    },
    deviceState() {
      //判断设备类型，决定右下角显示的样式
      return deviceTypeJudge1(this.oneDevice)
    },
    deviceViewType() {
      ///判断设备类型决定右上角显示的样式
      return deviceTypeJudge(this.oneDevice)
    }
  }
}
</script>
<style scoped>
.device-card {
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  height: 120px;
  padding: 12px;
  position: relative;
  border: 0;
  border-radius: 14px;
  background: rgba(248, 250, 255, 0.99);
  color: #202124;
  cursor: pointer;
  overflow: hidden;
}
.device-card--inactive, .device-card--neutral {
  background: rgba(198, 204, 212, 0.98);
  color: #202124;
}
.device-card.selected {
  background: rgba(218, 229, 255, 0.99);
  color: #202124;
}
.device-card-top {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: space-between;
  height: 42px;
}
.device-icon-surface {
  width: 42px;
  height: 42px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(78, 110, 242, 0.08);
  border-radius: 13px;
}
.device-card--inactive .device-icon-surface, .device-card--neutral .device-icon-surface {
  background: rgba(183, 190, 199, 0.92);
}
.device-card.selected .device-icon-surface { background: rgba(78, 110, 242, 0.08); }
.device-icon-surface img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.device-status-copy {
  min-width: 0;
  flex: 1;
  text-align: right;
  align-self: flex-start;
  padding-top: 0;
}
.device-card-status {
  font-size: 12px;
  line-height: 17px;
  color: #202124;
}
.device-card--active .device-card-status {
  color: #3558dc;
}
.device-card-detail {
  font-size: 11px;
  margin-top: 4px;
  color: #68707a;
  line-height: 16px;
}
.device-card-name {
  font-size: 16px;
  font-weight: 400;
  position: absolute;
  top: 68px;
  left: 12px;
  right: 12px;
  line-height: 18px;
}
.device-card.has-action .device-card-name { right: 60px; }
.device-card-bottom {
  position: absolute;
  bottom: 11px; left: 12px; right: 12px; height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 6px;
}
.device-card-region {
  font-size: 12px;
  color: #68707a;
  flex: 1;
  line-height: 16px;
}
.device-card-name,
.device-card-status,
.device-card-detail,
.device-card-region {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selection-badge {
  align-self: flex-start;
  font-size: 16px;
  color: var(--primary-color);
  font-weight: 600;
}
.quick-switch {
  width: 38px;
  height: 22px;
  border-radius: 10px;
  background: #9ea6b0;
  flex: none;
  padding: 2px;
  box-sizing: border-box;
}
.quick-switch i {
  display: block;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
}
.quick-switch.on {
  background: var(--primary-color);
}
.quick-switch.on i {
  margin-left: 16px;
}
.device-selection { right: 0; bottom: 0; }
</style>
